export default __webpack_public_path__ + "static/media/zodiac09.ef173bd3.png";